<template>
    <div>
        <el-row style="">
            <el-card class="box-card">
                <div slot="header" class="clearfix">
                    <span>数据量统计</span>
                    <div style="float: right; padding: 3px 0">
                        <el-date-picker v-model="formInline.daterange"
                                        type="daterange"
                                        value-format="yyyy-MM-dd"
                                        style="margin-right: 10px;"
                                        range-separator="至"
                                        @change="handleDate"
                                        start-placeholder="开始日期"
                                        end-placeholder="结束日期">
                        </el-date-picker>
                        <el-dropdown @command="handleCommand">
                            <el-button type="primary">
                                数据集<i class="el-icon-arrow-down el-icon--right"></i>
                            </el-button>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item :command="beforeHandleCommand(0,'all')">
                                    全部
                                </el-dropdown-item>
                                <el-dropdown-item :command="beforeHandleCommand(item.pk,'all')" :key="item.pk"
                                                  v-for="item in dynamicTags">{{item.name}}
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                </div>
                <el-col :span="24">
                    <el-dropdown @command="handleCommand">
                        <el-button type="primary">
                            数据集<i class="el-icon-arrow-down el-icon--right"></i>
                        </el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item :command="beforeHandleCommand(0,'drawPie')">
                                全部
                            </el-dropdown-item>
                            <el-dropdown-item :command="beforeHandleCommand(item.pk,'drawPie')" :key="item.pk"
                                              v-for="item in dynamicTags">{{item.name}}
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                    <div id="suifangfenbu"
                         style="height: 600px;"></div>
                </el-col>
            </el-card>
        </el-row>
        <el-row>
            <el-col :span="24">
                <el-row :gutter="20">
                    <el-col :span="8">
                        <el-card shadow="hover">
                            <div slot="header" class="clearfix">
                                <span>性别分布</span>
                                <el-dropdown @command="handleCommand" style="float: right;">
                                    <el-button type="primary">
                                        数据集<i class="el-icon-arrow-down el-icon--right"></i>
                                    </el-button>
                                    <el-dropdown-menu slot="dropdown">
                                        <el-dropdown-item :command="beforeHandleCommand(0,'xbzlchart')">
                                            全部
                                        </el-dropdown-item>
                                        <el-dropdown-item :command="beforeHandleCommand(item.pk,'xbzlchart')"
                                                          :key="item.pk" v-for="item in dynamicTags">{{item.name}}
                                        </el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </div>
                            <xingbiechart ref="xingbie"></xingbiechart>
                        </el-card>
                    </el-col>
                    <el-col :span="8">
                        <el-card shadow="hover">
                            <div slot="header" class="clearfix">
                                <span>年龄分布</span>
                                <el-dropdown @command="handleCommand" style="float: right;">
                                    <el-button type="primary">
                                        数据集<i class="el-icon-arrow-down el-icon--right"></i>
                                    </el-button>
                                    <el-dropdown-menu slot="dropdown">
                                        <el-dropdown-item :command="beforeHandleCommand(0,'')">
                                            全部
                                        </el-dropdown-item>
                                        <el-dropdown-item :command="beforeHandleCommand(item.pk,'')" :key="item.pk"
                                                          v-for="item in dynamicTags">{{item.name}}
                                        </el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </div>
                            <agecharts ref="agechart"></agecharts>
                        </el-card>
                    </el-col>
                    <el-col :span="8">
                        <el-card shadow="hover">
                            <div slot="header" class="clearfix">
                                <span>治疗状态</span>
                                <el-dropdown @command="handleCommand" style="float: right;">
                                    <el-button type="primary">
                                        数据集<i class="el-icon-arrow-down el-icon--right"></i>
                                    </el-button>
                                    <el-dropdown-menu slot="dropdown">
                                        <el-dropdown-item :command="beforeHandleCommand(0,'xbzlchart')">
                                            全部
                                        </el-dropdown-item>
                                        <el-dropdown-item :command="beforeHandleCommand(item.pk,'xbzlchart')"
                                                          :key="item.pk" v-for="item in dynamicTags">{{item.name}}
                                        </el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </div>
                            <piechart ref="zhiliaozhuangtai"></piechart>
                        </el-card>
                    </el-col>
                </el-row>
            </el-col>
        </el-row>
        <el-row>
            <el-card shadow="hover">
                <div slot="header" class="clearfix">
                    <span>数据趋势</span>
                    <el-dropdown @command="handleCommand" style="float: right;">
                        <el-button type="primary">
                            数据集<i class="el-icon-arrow-down el-icon--right"></i>
                        </el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item :command="beforeHandleCommand(0,'charttwo')">
                                全部
                            </el-dropdown-item>
                            <el-dropdown-item :command="beforeHandleCommand(item.pk,'charttwo')" :key="item.pk"
                                              v-for="item in dynamicTags">{{item.name}}
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
                <div>
                    <el-radio-group v-model="radio3" @change="getStatistics" size="small">
                        <el-radio-button :label="365">年</el-radio-button>
                        <el-radio-button :label="30">月</el-radio-button>
                        <el-radio-button :label="7">日</el-radio-button>
                    </el-radio-group>
                </div>
                <div id="shencunzhuangtai"
                     style="height: 500px;"></div>
            </el-card>
        </el-row>
    </div>
</template>

<script>
    import echarts from 'echarts'
    import PieChart from '../../components/PieChart'
    import XingbieChart from './widgets/xingbieCharts'
    import AgeCharts from './widgets/ageCharts'

    export default {
        components: {
            piechart: PieChart,
            xingbiechart: XingbieChart,
            agecharts: AgeCharts,
        },
        data() {
            return {
                dynamicTags: [],
                tableData: [],
                radio3: 7,
                command: 0,
                formInline: {
                    daterange: [],
                },
            }
        },
        methods: {
            handleDate() {
                // this.drawPie(this.command)
            },
            getStatistics() {
                this.charttwo(this.command)
            },
            handleCommand(command) {
                var type = command.type
                if (type == "all") {
                    this.command = command.command
                    this.xbzlchart(command.command)
                    this.drawPie(command.command)
                    this.charttwo(command.command)
                    this.$refs.agechart.init(command.command)
                } else {
                    if (type == "xbzlchart") {
                        this.xbzlchart(command.command)
                    } else if (type == "drawPie") {
                        this.drawPie(command.command)
                    } else if (type == "charttwo") {
                        this.charttwo(command.command)
                    } else {
                        this.$refs.agechart.init(command.command)
                    }
                }
            },
            beforeHandleCommand(item, type) {
                return {
                    'command': item,
                    'type': type
                }
            },
            drawLine(source) {
                let myChart = echarts.init(document.getElementById('shencunzhuangtai'))
                setTimeout(function () {
                    var option = {
                        legend: {},
                        tooltip: {
                            trigger: 'axis',
                            showContent: false
                        },
                        dataset: {
                            source: source
                        },
                        xAxis: {type: 'category'},
                        yAxis: {gridIndex: 0},
                        grid: {
                            left: '3%',
                            right: '3.5%',
                            bottom: '2%',
                            top: '50%',
                            containLabel: true
                        },
                        series: [
                            {type: 'line', smooth: true, seriesLayoutBy: 'row'},
                            {type: 'line', smooth: true, seriesLayoutBy: 'row'},
                            {type: 'line', smooth: true, seriesLayoutBy: 'row'},
                            {type: 'line', smooth: true, seriesLayoutBy: 'row'},
                            {type: 'line', smooth: true, seriesLayoutBy: 'row'},
                            {type: 'line', smooth: true, seriesLayoutBy: 'row'},
                            {
                                type: 'pie',
                                id: 'pie',
                                radius: '30%',
                                center: ['50%', '25%'],
                                label: {
                                    formatter: '{b}: {@' + source[0][1] + '} ({d}%)'
                                },
                                encode: {
                                    itemName: 'product',
                                    value: source[0][1],
                                    tooltip: source[0][1]
                                }
                            }
                        ]
                    };
                    myChart.on('updateAxisPointer', function (event) {
                        var xAxisInfo = event.axesInfo[0];
                        if (xAxisInfo) {
                            var dimension = xAxisInfo.value + 1;
                            myChart.setOption({
                                series: {
                                    id: 'pie',
                                    label: {
                                        formatter: '{b}: {@[' + dimension + ']} ({d}%)'
                                    },
                                    encode: {
                                        value: dimension,
                                        tooltip: dimension
                                    }
                                }
                            });
                        }
                    });

                    myChart.setOption(option);

                });
            },
            drawPie(pk) {
                // 基于准备好的dom，初始化echarts实例
                let myChart = echarts.init(document.getElementById('suifangfenbu'))
                // 绘制图表
                var option = {
                    title: {
                        text: '诊断数据分布',
                        x: 'center'
                    },
                    grid: {
                        left: '3%',
                        right: '3.5%',
                        bottom: '5%',
                        top: '0%',
                        containLabel: true
                    },
                    tooltip: {
                        trigger: 'item',
                        formatter: '{a} <br/>{b} : {c} ({d}%)'
                    },
                    legend: {
                        // orient: 'vertical',
                        // left: 'right'
                        padding: [10, 0, 10, 0],
                        y: 'bottom',
                    },
                    series: [
                        {
                            name: '诊断数据',
                            type: 'pie',
                            radius: '40%',
                            center: ['50%', '50%'],
                            data: [],
                            itemStyle: {
                                emphasis: {
                                    shadowBlur: 10,
                                    shadowOffsetX: 0,
                                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                                }
                            }
                        }
                    ]
                }
                var start = ''
                var end = ''
                if (this.formInline.daterange) {
                    end = this.formInline.daterange[1] || ''
                    start = this.formInline.daterange[0] || ''
                }
                var url = '/case/dashboard/diagnosis/'
                if (pk) {
                    url = url + pk + '/'
                }
                this.$http.get(url + '?start=' + start + '&end=' + end).then(res => {
                    if (res.data.code === 1) {
                        option['series'][0].data = res.data.data
                        myChart.setOption(option)
                    }
                })
            },
            xbzlchart(pk) {
                var url = '/case/dashboard/genderzl/'
                if (pk) {
                    url = url + pk + '/'
                }
                this.$http.get(url).then(res => {
                    this.dynamicTags = res.data.jihedata
                    this.$refs.xingbie.drawPie(res.data.data.xingbie)
                    this.$refs.zhiliaozhuangtai.drawPie(res.data.data.zhiliaozhuangtai)
                })
            },
            getData(pk) {
                var url = '/case/dashboard/'
                if (pk) {
                    url = url + pk + '/'
                }
                this.$http.get(url).then(resp => {
                    this.tableData = resp.data.xdata;
                });
            },
            charttwo(pk) {
                var url = '/case/dashboard/charttwo/'
                if (pk) {
                    url = url + pk + '/'
                }
                url = url + "?time=" + this.radio3
                var that = this
                this.$http.get(url).then(res => {
                    if (res.data.code === 1) {
                        var temp = [
                            ['product'],
                            ['缓解'],
                            ['失访'],
                            ['复发'],
                            ['死亡'],
                            ['生存(非缓解)'],
                            // ['总数'],
                        ]
                        // temp[6].push.apply(temp[6],res.data.data.bingli)
                        temp[5].push.apply(temp[5], res.data.data.shencun)
                        temp[4].push.apply(temp[4], res.data.data.siwang)
                        temp[3].push.apply(temp[3], res.data.data.fufa)
                        temp[2].push.apply(temp[2], res.data.data.shifang)
                        temp[1].push.apply(temp[1], res.data.data.huanjie)
                        temp[0].push.apply(temp[0], res.data.data.datatime)
                        that.drawLine(temp)
                    }
                })
            },
        },
        mounted() {
            this.xbzlchart()
            this.drawPie()
            this.getData()
            this.charttwo()
        }
    };
</script>
<style scoped>
    .el-row {
        margin-bottom: 20px;
        margin-left: 10px;
        margin-right: 10px;
        margin-top: 5px;
    }

</style>
